import { render } from "./Main.vue?vue&type=template&id=66936d0a"
const script = {}
script.render = render

export default script